import axios from 'axios';

const version = 'v1';
const basePath = 'pallet';

export async function getLabel(pallet_id) {
  return axios.request({
    url: `/${version}/${basePath}/${pallet_id}/label`,
    method: 'get',
  });
}
